import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./styles/index.scss";
import { store } from "./redux/store";
import { Provider } from "react-redux";
import "./styles/font.css";
import TagManager from "react-gtm-module";
import { HelmetProvider } from 'react-helmet-async';
import { GoogleOAuthProvider } from '@react-oauth/google';



// Initialize Google Tag Manager
const tagManagerArgs = {
  gtmId: "GTM-PXNLVW5X", // Replace with your actual GTM ID
};


TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <HelmetProvider>
    <GoogleOAuthProvider clientId="836612524230-0tolohcdap34h5lcptf1lv62n3o1no98.apps.googleusercontent.com">

    <Provider store={store}>
      <App />
    </Provider>
    </GoogleOAuthProvider>

    </HelmetProvider>
  // </React.StrictMode>
);
